export default __webpack_public_path__ + "71e57de4607ef1f0deb4b0d8a7e98ed8.jpg";